var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "note_add"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1008_11014",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 74
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.895996,
    y: 0.292969,
    width: 73.208,
    height: 73.208,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1008_11014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "note_add_2",
    d: "M35.2123 54.4374H39.7877V45.2864H48.9387V40.711H39.7877V31.56H35.2123V40.711H26.0613V45.2864H35.2123V54.4374ZM20.1366 65.8761C18.5958 65.8761 17.2916 65.3423 16.224 64.2747C15.1564 63.2071 14.6226 61.9028 14.6226 60.362V13.434C14.6226 11.8932 15.1564 10.589 16.224 9.52135C17.2916 8.45373 18.5958 7.91992 20.1366 7.91992H44.3633L60.3774 23.934V60.362C60.3774 61.9028 59.8436 63.2071 58.776 64.2747C57.7084 65.3423 56.4041 65.8761 54.8633 65.8761H20.1366ZM42.0756 26.2218H55.802L42.0756 12.4953V26.2218Z",
    fill: "#4F3DD1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteAdd);
export default __webpack_public_path__ + "static/media/note-add.917d92ee4b9ce78bae46c6161a6f25fb.svg";
export { ForwardRef as ReactComponent };